import Vue from "vue";
import VueRouter from "vue-router";

import Login from "./components/auth/Login";
import Logout from "./components/auth/Logout";
import AboutDepositPage from "./components/about/Deposit";
import About from "./components/about/About";
import Career from "./components/career/Page";
import MainTextBlock from "./components/main/MainTextBlock";
import Slider from "./components/main/Page";
import Mission from "./components/mission/Page";
import NewsPage from "./components/news/Page";
import Content from "./components/content/Content";

Vue.use(VueRouter);

const routes = [
  {
    path: "/admin",
    redirect: "/admin/slider",
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/login",
    name: "Login",
    component: Login
  },
  {
    path: "/admin/logout",
    name: "Logout",
    component: Logout,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: "/admin/slider",
    name: "Slider",
    component: Slider,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin/main",
    name: "Main",
    component: MainTextBlock,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin/about",
    name: "About",
    component: About,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin/about-list",
    name: "About",
    component: AboutDepositPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin/mission",
    name: "Mission",
    component: Mission,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin/career",
    name: "Career",
    component: Career,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin/news",
    name: "News",
    component: NewsPage,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: "/admin/news/:id/content/:lang",
    name: "Content",
    component: Content,
    props: (route) => {
      return { id: 1 * route.params.id, lang: route.params.lang };
    },
    meta: {
      requiresAuth: false
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    console.log('requiresAuth');
    if (!window.localStorage.getItem("token")) {
      console.log('requiresAuth');
      next({ path: "/admin/login" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
